import { z } from 'zod';
import { MapLocation, mapLocationSchema } from 'app/agriculture/queries/types/MapLocation';

export interface Note {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    text: string;
    location: MapLocation | null;
    parentId: string | null;
}

export const noteSchema = z.object({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    text: z.string(),
    location: mapLocationSchema.nullable(),
    parentId: z.string().uuid().nullable(),
});

export function mockNote({
    id = '105fbd4f-a896-42d5-b444-1c87f63cdd1b',
    text = 'text',
    creatorId = 0,
    parentId = null,
    location = null,
    createdAt = new Date(),
    updatedAt = new Date(),
}: Partial<Note> = {}): Note {
    return { id, text, creatorId, parentId, location, createdAt, updatedAt };
}
